import React, { useContext } from 'react';
import { Row, Col, Typography } from 'antd';
import {
    PlusSquareOutlined,
    DeploymentUnitOutlined,
    ShareAltOutlined,
    SafetyCertificateOutlined,
    SkinOutlined,
} from '@ant-design/icons';
import { ThemeContext } from '../Context/ThemeContext';

const { Text } = Typography;
const WelcomeCard = () => {
    const { theme } = useContext(ThemeContext);
    return (
        <div>
            <Row align='middle' justify='center' style={{ padding: '1rem 0' }}>
                <Text
                    style={{
                        color: theme.content.text,
                        fontSize: '1.5rem',
                        padding: '0.5rem 0',
                        textAlign: 'center',
                    }}
                    strong
                >
                    Welcome! <br />
                    Let's get you started
                </Text>
            </Row>
            <Row align='middle' justify='center' style={{ padding: '1rem 0' }}>
                {/* About Add New Section */}
                <Col xs={4} sm={3}>
                    <PlusSquareOutlined
                        style={{
                            color: '#52c41a',
                            padding: '1rem 1rem 1rem 0',
                            fontSize: '3rem',
                        }}
                    />
                </Col>
                <Col
                    xs={20}
                    sm={21}
                    style={{
                        fontSize: '1.2rem',
                        color: theme.content.text,
                    }}
                >
                    Add your first update, say Hi
                    <span role='img' aria-label='hand wave'>
                        {' '}
                        👋{' '}
                    </span>
                    to the community!
                </Col>
            </Row>
            <Row align='middle' justify='center' style={{ padding: '1rem 0' }}>
                {/* About Explore Section */}
                <Col xs={4} sm={3}>
                    <DeploymentUnitOutlined
                        style={{
                            color: 'grey',
                            padding: '1rem 1rem 1rem 0',
                            fontSize: '3rem',
                        }}
                    />
                </Col>
                <Col
                    xs={20}
                    sm={21}
                    style={{
                        fontSize: '1.2rem',
                        color: theme.content.text,
                    }}
                >
                    Explore the community, get latest updates from friends,
                    followers and people your follow. Looking to explore new
                    people, checkout global community updates in explore
                    section.
                </Col>
            </Row>
            <Row align='middle' justify='center' style={{ padding: '1rem 0' }}>
                {/* About Profile Section */}
                <Col xs={4} sm={3}>
                    <SkinOutlined
                        style={{
                            color: 'purple',
                            padding: '1rem 1rem 1rem 0',
                            fontSize: '3rem',
                        }}
                    />
                </Col>
                <Col
                    xs={20}
                    sm={21}
                    style={{
                        fontSize: '1.2rem',
                        color: theme.content.text,
                    }}
                >
                    Profile section let's you customise the app based on your
                    preferences - from dark mode to private accounts, we got you
                    covered!
                </Col>
            </Row>
            <Row align='middle' justify='center' style={{ padding: '1rem 0' }}>
                {/* About Share Section */}
                <Col xs={4} sm={3}>
                    <ShareAltOutlined
                        style={{
                            color: '#eb2f96',
                            padding: '1rem 1rem 1rem 0',
                            fontSize: '3rem',
                        }}
                    />
                </Col>
                <Col
                    xs={20}
                    sm={21}
                    style={{
                        fontSize: '1.2rem',
                        color: theme.content.text,
                    }}
                >
                    Make your friends part of your life, invite friends to the
                    app and share your updates with them.
                </Col>
            </Row>
            <Row justify='center' style={{ padding: '1rem 0' }}>
                {/* About Share Section */}
                <Col xs={4} sm={3}>
                    <SafetyCertificateOutlined
                        style={{
                            color: theme.content.text,
                            padding: '1rem 1rem 1rem 0',
                            fontSize: '3rem',
                        }}
                    />
                </Col>
                <Col
                    xs={20}
                    sm={21}
                    style={{
                        fontSize: '1.2rem',
                        color: theme.content.text,
                    }}
                >
                    Let's do some privacy check FAQs before you get started
                    <Row
                        align='middle'
                        justify='center'
                        style={{ padding: '1rem 0' }}
                    >
                        {/* FAQ on updates Section */}
                        <Col
                            xs={24}
                            style={{
                                fontSize: '1.2rem',
                                color: theme.content.text,
                            }}
                        >
                            Q. Who can see your updates?
                        </Col>
                        <Col
                            xs={24}
                            style={{
                                fontSize: '1.2rem',
                                color: theme.content.text,
                            }}
                        >
                            <i>Answer:</i>
                            <ol>
                                <li>
                                    <b>Public accounts</b> : Anyone on the
                                    internet!
                                </li>
                                <li>
                                    <b>Private accounts</b> : You, your friends
                                    and people you follow.
                                </li>
                            </ol>
                        </Col>
                    </Row>
                    <Row
                        align='middle'
                        justify='center'
                        style={{ padding: '1rem 0' }}
                    >
                        {/* FAQ on friend */}
                        <Col
                            xs={24}
                            style={{
                                fontSize: '1.2rem',
                                color: theme.content.text,
                            }}
                        >
                            Q. Who is a friend?
                        </Col>
                        <Col
                            xs={24}
                            style={{
                                fontSize: '1.2rem',
                                color: theme.content.text,
                            }}
                        >
                            <i>Answer:</i> Someone you follow and you are
                            followed back.
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default WelcomeCard;
